<template>
  <div class="gs-app" :class="{ 'is-home': isHome, 'has-full-banner': hasFullBanner }">
    <header class="gs-header" ref="headerEl">
      <Header />
      <Breadcrumb v-show="!isHome" />
    </header>
    <div class="gs-header-spacer" :style="{ height: headerH + 'px' }" aria-hidden="true"></div>
    <div class="gs-stage">
      <div class="gs-page-shell">
        <router-view />
      </div>
    </div>
    <footer class="gs-footer">
      <FooterData />
    </footer>
    <BackUP />
  </div>
</template>

<script>
import Header from './components/Header'
import BackUP from '@/views/Layout/BackUP.vue'

export default {
  name: 'MainLayout',
  components: {
    Header,
    BackUP
  },
  data() {
    return {
      headerH: 72
    }
  },
  computed: {
    isHome() {
      const path = this.$route.path
      return path === '/' || path === '/Home'
    },
    hasFullBanner() {
      const path = String(this.$route.path || '').replace(/\/+$/, '') || '/'
      if (
        path === '/hall' ||
        path === '/datasets' ||
        path === '/providers' ||
        path === '/demand' ||
        path === '/map' ||
        path === '/enterprises' ||
        path === '/news' ||
        path === '/news/express' ||
        path === '/resources' ||
        path === '/college' ||
        path === '/lab' ||
        path === '/interviews' ||
        path === '/experts'
      ) return true
      return path.indexOf('/map/') === 0
    }
  },
  watch: {
    '$route.path'() {
      this.$nextTick(this.syncHeaderH)
    }
  },
  mounted() {
    this.syncHeaderH()
    this._onHeaderResize = () => this.syncHeaderH()
    window.addEventListener('resize', this._onHeaderResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this._onHeaderResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onHeaderResize)
  },
  methods: {
    syncHeaderH() {
      const el = this.$refs.headerEl
      const h = el ? el.offsetHeight : 72
      if (h && h !== this.headerH) this.headerH = h
      document.documentElement.style.setProperty('--gs-header-h', (h || 72) + 'px')
    }
  }
}
</script>

<style scoped>
.gs-app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  overflow-x: clip;
  background: transparent;
}
.gs-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  max-width: none;
}
.gs-header-spacer {
  flex: 0 0 auto;
  width: 100%;
}
.gs-stage {
  flex: 1;
  width: 100%;
  position: relative;
}
.gs-page-shell {
  width: 100%;
  max-width: var(--gs-main-width, 1250px);
  margin: 0 auto;
  box-sizing: border-box;
  overflow: visible;
}
.is-home .gs-page-shell {
  max-width: none;
  padding: 0;
}
.has-full-banner .gs-page-shell {
  overflow: visible;
}
.gs-footer {
  width: 100%;
}
@media (max-width: 1249px) {
  .gs-app:not(.is-home):not(.has-full-banner) .gs-page-shell {
    max-width: 100%;
    padding: 0 16px;
  }
  .gs-app.has-full-banner .gs-page-shell {
    max-width: 100%;
    padding: 0;
  }
}
@media (max-width: 960px) {
  .gs-app:not(.is-home):not(.has-full-banner) .gs-page-shell {
    padding: 0 12px;
  }
}
</style>
